module.exports = __webpack_public_path__ + "static/media/18001.e957d28f.jpg";